<template>
<div v-if="item[column.name]" style="text-align: xright">
  {{ item[column.name] }}
</div>
<div v-else-if="priceRangeMin && priceRangeMin==priceRangeMax" style="text-align: xright">
  {{ priceRangeMin }}
</div>
<div v-else-if="priceRangeMin" style="text-align: xright">
  {{ priceRangeMin }} - {{ priceRangeMax }}
</div>
<div v-else style="text-align: xright">
  (not set)
</div>
</template>

<script>
export default {
  props: {
    item: {},
    column: {},
  },
  computed: {
    priceRangeMin() {
      if (!this.item.children?.length)
        return null;
      var prices=this.item.children.map(item=>item[this.column.name]).filter(price=>price);
      if (prices.length)
        return Math.min(...prices).toFixed(2);
      return null;
    },
    priceRangeMax() {
      if (!this.item.children?.length)
        return null;
      var prices=this.item.children.map(item=>item[this.column.name]).filter(price=>price);
      if (prices.length)
        return Math.max(...prices).toFixed(2);
      return null;
    },
  },
}
</script>
